export const CANDY_MACHINE_ID = "AP7vXZsATmjkuKQKF5cBbDrC8AN9FzbHxxcjjZeFWCyC";
export const CANDY_MACHINE_PRESALE_MAX_MINT = 2;
export const CANDY_MACHINE_MAX_MINT = 5;
export const CANDY_MACHINE_OFFSET = 112;
export const SOLANA_NETWORK = "mainnet-beta";
export const WHITELIST_TOKEN = "HQV1HfJAYHibb3m8Rfpb6HPDd81Th9vdS7ovT2RgpBHc";
